import styled from 'styled-components';

export const EventInformationWrapper = styled.div`
	@media(min-width: 991px){
		display: flex;
		gap: 20px;
	}
`;
